import { FormControl, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AppServerAPI, SelectFieldOption } from '@sdbn/common';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject, Subscription } from 'rxjs';
import { EquipmentType } from '../../tmc-common-equipment/common/equipment.model';

@Component({
  selector: 'tc-equipment-condition-editor',
  standalone: false,
  templateUrl: './equipment-condition-editor.component.html',
  styleUrl: './equipment-condition-editor.component.scss',
})
export class EquipmentConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    value: new FormControl(null, [])
  });

  selectFieldOptions: Array<SelectFieldOption>;
  tmcContextSubscription: Subscription;

  constructor(
    private appServerAPI: AppServerAPI
  ) {

  }

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    this.appServerAPI.execute<EquipmentType[]>('/tmc-common/equipment/getAll', null).subscribe(response => {
      if (response) {
        let selectFieldOptions = new Array<SelectFieldOption>();
        for (let type of response) {
         selectFieldOptions.push(new SelectFieldOption({ label: type.name, value: type.id }));
        }
        this.selectFieldOptions = selectFieldOptions;
      }
    });


    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.value;
    });

    // for (const key of Object.keys(TransportType)) {
    // }

  }

}
